export const getBaseUrl = () => {
  return `${window.location.protocol}//${window.location.host}`;
};